import React from "react";
import "./QuestionnaireTextSVG.less";

interface SVGComponentProps {
  scale?: number;
}

export const QuestionnaireTextSVG: React.FC<SVGComponentProps> = ({ scale = 1 }) => (
  <svg
    viewBox="0 0 105 68"
    className="input-svg"
    style={{ transform: `scale(${scale})` }}
    width="105"
    height="68"
  >
    <text x="29" y="15">
      Your
    </text>
    <text x="16" y="41">
      message
    </text>
    <text x="31" y="67">
      here
    </text>
  </svg>
);
